import React from "react";
import { Container } from "react-bootstrap";
import { Grid, Skeleton } from "@mui/material";

const SeriesSkeleton = () => {
  return (
    <Container>
      <Grid container spacing={2}>
        {/* Left Skeleton */}
        <Grid item xs={12} md={6}>
          <Skeleton
            variant="rectangular"
            height={250}
            animation="wave"
            sx={{
              width: "100%",
              maxHeight: "250px",
              bgcolor: "grey.300", // darker base for better contrast
              "&::after": {
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)", // brighter shimmer
              },
            }}
          />
        </Grid>

        {/* Right Skeleton */}
        <Grid item xs={12} md={6}>
          <Skeleton
            variant="rectangular"
            height={250}
            animation="wave"
            sx={{
              width: "100%",
              maxHeight: "250px",
              bgcolor: "grey.300",
              "&::after": {
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
              },
            }}
          />
        </Grid> 
      </Grid>
    </Container>
  );
};

export default SeriesSkeleton;
